/**
 * Launch identity configuration for the current single-tenant deployment.
 *
 * IMPORTANT:
 * - These values are accepted only as launch-phase placeholders.
 * - They are NOT the long-term multi-tenant identity model.
 * - P2-04 will replace these with server-side requirePrincipal() resolution.
 *
 * @see convex/lib/requirePrincipal.ts — the server-side replacement
 */

/**
 * Default tenant ID for single-tenant deployment.
 * Used across classification, chat, and bulk operations.
 *
 * @deprecated P2-04 will resolve tenantId server-side via requirePrincipal().
 *             Do NOT add new usages of this constant.
 */
export const LAUNCH_TENANT_ID = "default" as const;

/**
 * Launch-phase placeholder user identity for unauthenticated / fallback flows.
 *
 * @deprecated Replaced by Auth0 user.sub via requirePrincipal() (P0-04).
 *             Do NOT use in new code — authenticated identity is always available.
 */
export const LAUNCH_ANONYMOUS_USER_ID = "anonymous" as const;

/**
 * Launch-phase placeholder user identity for bulk upload processing.
 *
 * @deprecated P2-04 will resolve batch ownership server-side via requirePrincipal().
 *             Do NOT add new usages of this constant.
 */
export const LAUNCH_BULK_UPLOAD_USER_ID = "bulk-upload" as const;

/**
 * Launch-phase placeholder used by legacy single-turn classification form.
 *
 * @deprecated P2-04 will resolve userId server-side via requirePrincipal().
 *             Do NOT add new usages of this constant.
 */
export const LAUNCH_WEB_USER_ID = "web_user" as const;

/**
 * Type alias for compile-time tenant validation
 */
export type TenantId = typeof LAUNCH_TENANT_ID;

/**
 * Known launch placeholder user IDs.
 */
export type LaunchUserId =
  | typeof LAUNCH_ANONYMOUS_USER_ID
  | typeof LAUNCH_BULK_UPLOAD_USER_ID
  | typeof LAUNCH_WEB_USER_ID;
